import { isRichMessageActionWithOptionalFallbackParams } from 'components/flowBuilder/types/actions/typeGuards';
import {
  MessageCounts,
  MessageFieldPreview,
  MessagePreview,
} from 'components/flowBuilder/types/messages';

export const isMessageCounts = (counts: unknown): counts is MessageCounts => {
  const countsValue = counts as MessageCounts;

  if (!countsValue || typeof countsValue !== 'object') return false;
  if (typeof countsValue.characterCount !== 'number') return false;
  if (typeof countsValue.divisor !== 'number') return false;
  if (typeof countsValue.messageCount !== 'number') return false;
  if (typeof countsValue.specificMessageType !== 'string') return false;

  return true;
};

export const isMessagePreview = (
  preview: unknown,
): preview is MessagePreview => {
  const previewValue = preview as MessagePreview;

  if (!previewValue || typeof previewValue !== 'object') return false;
  if (
    previewValue.params &&
    !isRichMessageActionWithOptionalFallbackParams(previewValue.params)
  )
    return false;
  if (typeof previewValue.preview !== 'string') return false;

  return true;
};

export const isMessageFieldPreview = (
  response: unknown,
): response is MessageFieldPreview => {
  const responseValue = response as MessageFieldPreview;

  if (!responseValue || typeof responseValue !== 'object') return false;
  if (typeof responseValue.preview !== 'string') return false;
  if (!isMessageCounts(responseValue.previewCharacterCount)) return false;

  return true;
};
